import { useQuery } from '@tanstack/react-query'

import type { VesselMetricsPayload } from '@ankor-io/common/types/lighthouse'

import { lighthouseService } from '@/api/services'

export const dashboardKeys = {
  vesselMetrics: () => ['dashboard', 'vessel-metrics'] as const,
}

export function useVesselMetricsQuery(options?: { enabled?: boolean }) {
  return useQuery<VesselMetricsPayload, Error>({
    queryKey: dashboardKeys.vesselMetrics(),
    queryFn: () => lighthouseService.getVesselMetrics(),
    enabled: options?.enabled !== false,
    // These metrics aggregate the whole platform from a DB view; they do not
    // change second-to-second, so avoid refetching on every remount/refocus.
    staleTime: 60_000,
  })
}
